import Api from '../api/reconApi.js';
import * as getInfo from './apiGetInfo';
import * as AllMutates from './AllMutates';

export function addDealerSetting(data, errorType) {
	return dispatch => Api.postData('dealer_settings/', data).then(() => {
		dispatch(getInfo.getDealerSettings({}));
		return 'success';
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateInstallation(id, data, errorType) {
	return dispatch => Api.patchData(`installations/${id}`, data).then(() => {
		dispatch(getInfo.getInstallation());
		return 'success';
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function deactivateInstallation(id, data, errorType) {
	return dispatch => Api.patchData(`installations/${id}/deactivate`, data).then(() => {
		dispatch(getInfo.getUser());
		return 'success';
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function addTabSetting(data, errorType) {
	return dispatch => Api.postData('tabs/', data).then(() => {
		dispatch(getInfo.getTabs({}));
		return 'success';
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateTabSetting(id, data, errorType) {
	return dispatch => Api.patchData(`tabs/${id}`, data).then(() => {
		dispatch(getInfo.getTabs({}));
		return 'success';
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateTabSettingRaw(id, data, errorType) {
	return dispatch => Api.patchData(`tabs/${id}`, data).then(() => {
		dispatch(getInfo.getTabs({}));
		return 'success';
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateTabOrder(tabs, errorType) {
	return (dispatch) => {
		tabs.map((tabs, i) => {
			const data = {
				id: tab.id,
				order: i,
			};

			return Api.patchData(`tabs/${tab.id}`, data).then(() => {
			}).catch(ex => Api.handleApiError(ex, errorType));
		});

		dispatch(getInfo.getTabs());
	};
}

export function updateTabPropertiesOrder(tab_properties) {
	const errorType = 'TabPropertyOrder';
	return (dispatch) => {
		tab_properties.map((tab_property, i) => {
			const data = {
				id: tab_property,
				order: i,
			};

			return Api.patchData(`tab_properties/${tab_property}`, data).then(() => {
			}).catch(ex => Api.handleApiError(ex, errorType));
		});

		dispatch(getInfo.getTabs());
	};
}


export function addTabProperty(data, errorType) {
	return dispatch => Api.postData('tab_properties/', data).then(() => {
		dispatch(getInfo.getTabs({}));
		return 'success';
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateTabProperty(id, data, errorType) {
	return dispatch => Api.patchData(`tab_properties/${id}`, data).then(() => {
		dispatch(getInfo.getTabs({}));
		return 'success';
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function deleteTabProperty(id, errorType) {
	return dispatch => Api.delete(`tab_properties/${id}`).then(() => {
		dispatch(getInfo.getTabs({}));
	}).catch(ex => Api.handleApiError(ex, errorType));
}
